import React from "react";
import styled from "styled-components";
import { useSegment } from "analytics/segment";
import { TaskSubjectType } from "core/queries/GetTask";
import {
  GetUserRelatedBookingInquiry,
  GetUserRelatedBookingLeaseInquiry,
  GetUserRelatedBookingTomBooking,
} from "core/queries/GetUserRelatedTasks";
import { AccountDetailsLoader } from "tasks/components/TaskPanel/Guest/AccountDetails.loader";
import { InfoCard } from "tasks/components/TaskPanel/InfoCard";
import { formatAccountName } from "tasks/helpers";

const LoaderContainer = styled.div`
  padding: 1.714rem 0.964rem 1.714rem 1.714rem;
`;

interface GuestInfoCardProps {
  loading: boolean;
  booking:
    | GetUserRelatedBookingInquiry
    | GetUserRelatedBookingLeaseInquiry
    | GetUserRelatedBookingTomBooking
    | null
    | undefined;
  taskId: string;
}

export const GuestInfoCard = ({
  loading,
  booking,
  taskId,
}: GuestInfoCardProps) => {
  const { track } = useSegment();

  if (loading && !booking)
    return (
      <LoaderContainer>
        <AccountDetailsLoader />
      </LoaderContainer>
    );

  if (!booking) return null;

  const account = booking?.account;
  const isLeaseInquiry = booking.__typename === TaskSubjectType.LeaseInquiry;

  const numberOfBookings = account?.numberOfBookings || 0;
  const numberOfStaysText = `${numberOfBookings} total ${
    numberOfBookings !== 1 ? "stays" : "stay"
  }`;
  const accountName =
    isLeaseInquiry && !account
      ? (booking as GetUserRelatedBookingLeaseInquiry).name || "(Unknown)"
      : formatAccountName(account);

  const subtext =
    isLeaseInquiry && !account ? "(Click for more details)" : numberOfStaysText;

  const onClick = () => {
    if (!booking.bookingUrl) return;
    track({
      eventName: "task_panel",
      action: "click",
      element: "inquiry_link_guest",
      props: { taskId },
    });
    window.open(`${booking.bookingUrl}#guest`, "_blank");
  };

  return (
    <InfoCard
      avatarName={accountName}
      subtext={subtext}
      text={accountName}
      onClick={onClick}
    />
  );
};
